import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withTranslation } from 'react-i18next'
import { yesNoModal } from '../../../actions/common'
import { fetchControlSemen, deleteControlSemen, abrirModalInicio, descargarArchivoControlSemen, recuperarDatosModalControlSemen, abrirModalControlSemen, closeModalControlSemen, guardarDetalleControlSemen, subirArchivosInforme} from '../../../actions/planSanitario/controlSemen/controlSemen'
import ModalControlSemen from '../../../components/planSanitario/controlSemen/ModalControlSemen'

export function mapStateToProps (state) {
  return {
    ...state.controlSemen,
    auth: state.auth,
    paginaActual: state.common.paginaActual,
    combos: {comboResultadoControlSemen: state.combos.comboResultadoControlSemen}
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      fetchControlSemen,
      deleteControlSemen,
      yesNoModal,
      abrirModalInicio,
      descargarArchivoControlSemen,
      recuperarDatosModalControlSemen,
      closeModalControlSemen,
      abrirModalControlSemen,
      guardarDetalleControlSemen,
      subirArchivosInforme
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ModalControlSemen))